import { useContext, useEffect, useRef, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import helpers from "src/utils/helpers"
import { Filter, Portal, ServerSideTable } from "src/component"
import { AppText, Button, CustomContainer, FlexRow } from "src/style"
import {sandboxUsersColumns, sandboxUsersData} from 'src/utils/table-layout'
import { Add_Edit_SandboxUser } from "src/popup"
import { useNotifier } from "react-pop-notifier"

export const SandboxUsers = () => {
    const {API, downloadReport} = useContext(ApiContext)
    const {decisionBox} = useContext(VisibilityContext)
    const {notifier} = useNotifier()
    const [reportData, setReportData] = useState<any>(null)
    const [report, setReport] = useState<any>(null)
    const [resetPagination, setResetPagination] = useState<boolean>(false)
    const [selectedRow, setSelectedRow] = useState(null)
    const [view, setView] = useState<string>('')
    
    const filterDataRef = useRef({})

    useEffect(() => {
        filterDataRef.current = {}
        handleFetchReport()
    }, [])

    async function handleFetchReport (pageNumber = 1, pageSize = 10, isDownload = false) {
        const response = {data: sandboxUsersData, total: 4}

        if (response) {
            if (isDownload) {
                return downloadReport(response, 'SANDBOX_USERS_REPORT')
            }

            response.data = helpers.addSerialNumberToItems(response?.data, {pageNumber, pageSize})

            setReportData(response)
            setReport(response.data)
        }
    }

    function handleClear () {
        filterDataRef.current = {}
        handleFetchReport()
        setResetPagination(!resetPagination)
    }

    function handleRowAction (row: any, actionType: string) {
        if (actionType === 'edit') {
            setView('edit-user')
            setSelectedRow(row)
        }
        else {
            decisionBox.show(
                `Are you sure you want to disable sandbox user?`,
                handleDisableUser,
                decisionBox.hide,
                `Yes, Disable`,
                'No'
            )
        }
    }

    function handleDisableUser () {
        notifier.show('Sandbox User Successfully Disabled', null, 'success')
    }

    return (
        <>
            <CustomContainer>
                <FlexRow 
                    justifyContent='space-between' alignItems='flex-start' 
                    bottomMargin='1.5' gap='1.5' wrap='wrap'
                >
                    <AppText textSize='2' color='#101828' fontWeight="500">
                        Sandbox Users
                    </AppText>
                    <Button
                        width='20' fontWeight="500"
                        height='4' radius='0.8' hoverColor='#0D968F'
                        hoverBgColor='#fff' borderColor='#0D968F'
                        onClick={() => setView('new-user')}
                    >
                        Add New Sandbox User
                    </Button>
                </FlexRow>
                <ServerSideTable
                    tableData={report}
                    tableColumns={sandboxUsersColumns(handleRowAction)} 
                    dataFetchMethod={handleFetchReport}
                    totalRows={reportData?.total}
                    customStyle
                    shouldResetPagination={resetPagination}
                    canFilter={() => setView('filter')}
                    canClear={handleClear}
                    downloadAction={() => handleFetchReport(1, 10, true)}
                />
            </CustomContainer>
            { view === 'filter' &&
                <Portal>
                    <Filter
                        type='sandbox-users'
                        onApplyFilter={handleFetchReport}
                        setFilterData={(data: any) => {filterDataRef.current = data}}
                        close={() => setView('')}
                    />
                </Portal>
            }
            { ['new-user' ,'edit-user'].includes(view) &&
                <Add_Edit_SandboxUser 
                    getSandboxUsers={() => {
                        filterDataRef.current = {};
                        handleFetchReport()
                    }}
                    rowData={selectedRow}
                    close={() => setView('')}
                />
            }
        </>
    )
}